'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pixi = require('pixi.js');

var _pixi2 = _interopRequireDefault(_pixi);

var _TimerManager = require('./TimerManager');

var _TimerManager2 = _interopRequireDefault(_TimerManager);

var _Timer = require('./Timer');

var _Timer2 = _interopRequireDefault(_Timer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timer = {
  TimerManager: _TimerManager2.default,
  Timer: _Timer2.default
};

if (!_pixi2.default.timerManager) {
  _pixi2.default.timerManager = new _TimerManager2.default();

  _pixi2.default.timer = timer;
}

exports.default = timer;


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 4
 ** module chunks = 0
 **/